export default {"src":"/_next/static/media/icon-cart.e3743500.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};